module.exports = __webpack_public_path__ + "static/media/compreblindados-alpha.80fcef90.png";